import React from 'react';
import { Col, Row } from 'reactstrap';
import { Nps } from '../../../../entities/survey_engine/Nps';
import { Trend } from '../../Trend';
import { NpsChip } from './NpsChip';
import { OverallNpsCharts } from './OverallNpsCharts';

interface PropTypes {
  nps: Nps;
  npsTrend?: number;
  detractorsText: string;
  neutralsText: string;
  promotersText: string;
  standardNpsCalculation?: boolean;
  hasCandidatePulseCnps?: boolean;
}

export function OverallNpsContent(props: PropTypes) {
  return (
    <div className='d-flex align-items-center h-100'>
      <Row>
        <Col xs={7} className='px-4 d-flex flex-column align-items-center'>
          <OverallNpsCharts
            nps={props.nps}
            standardNpsCalculation={props.standardNpsCalculation}
            hasCandidatePulseCnps={props.hasCandidatePulseCnps}
          />
          <div className='mt-3 fs-6'>
            <Trend trend={props.npsTrend} />
          </div>
        </Col>
        <Col className='d-flex flex-column justify-content-center ps-4 pe-0'>
          <dl className='row mb-0'>
            <NpsChip
              npsRatio={props.nps.detractors}
              npsText={props.detractorsText}
            />
            <NpsChip
              npsRatio={props.nps.neutrals}
              npsText={props.neutralsText}
            />
            <NpsChip
              npsRatio={props.nps.promoters}
              npsText={props.promotersText}
            />
          </dl>
        </Col>
      </Row>
    </div>
  );
}
